import {Box} from '@primer/styled-react'
import {clsx} from 'clsx'
import type React from 'react'

import styles from './Panel.module.css'

interface PanelProps {
  children: React.ReactNode
  sx?: Record<string, unknown>
  id?: string
  className?: string | undefined
  style?: React.CSSProperties
}

export const Panel: React.FC<PanelProps> = ({children, sx, className, ...rest}) => {
  return (
    <Box sx={sx} className={clsx(styles.Box, className)} {...rest}>
      {children}
    </Box>
  )
}
